 
import {
    FETCH_GETALLCOMPANIES_REQUEST,
    FETCH_GETALLCOMPANIES_SUCCESS,
    FETCH_GETALLCOMPANIES_FAILURE,
    SET_SELECTED_GETALLCOMPANIES,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchAllCompany = (searchTerm = '') => async (dispatch) => {
    dispatch({ type: FETCH_GETALLCOMPANIES_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetAllCompaniesDDL?Search=${searchTerm}`);
      // console.log("GETALLCOMPANIES :" , response );
      
      let getAllcompaniesList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
          tag:val.tag
        }
    })
      dispatch({
        type: FETCH_GETALLCOMPANIES_SUCCESS,
        payload: getAllcompaniesList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GETALLCOMPANIES_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectGetCompanies = (getallcompaniesId) => ({
    type: SET_SELECTED_GETALLCOMPANIES,
    payload: getallcompaniesId,
  });
  